import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Header from '../Header';

const PricingDetail = () => {
  const { cityId, freezoneId } = useParams();

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="mx-auto flex max-w-3xl flex-col px-4 py-12 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="text-2xl font-bold text-slate-900">Pricing Detail Moved</h1>
          <p className="mt-2 text-sm text-slate-600">
            Pricing is now managed directly on the freezone pricing screen for a cleaner create/edit workflow.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to={`/cities/${cityId}/freezones/${freezoneId}`}
              className="inline-flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              Go To Freezone Pricing
            </Link>
            <Link
              to="/cities"
              className="inline-flex items-center rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              Back To Cities
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingDetail;
